import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type BillMarkAsPaidParams = {
  id: string;
};

export const billMarkAsPaidAtom = createMutationAtomFactory(
  'finance.billMarkAsPaid',
  (params: BillMarkAsPaidParams) => ({
    financeBillMarkAsPaid: {
      __args: {
        id: params.id,
      },
      id: true,
      documentNumber: true,
      status: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
